import * as LabelPrimitive from '@radix-ui/react-label';
import { type ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/*
 * shadcn/ui Label — generated primitive built on Radix Label, which
 * wires the `htmlFor`/`id` association for accessibility. Always pair
 * a control with a Label (WCAG AA — labelled controls).
 */
function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm font-medium leading-none select-none',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
